import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

import { DesignTokens } from "melco-ui";

const { sizes, colors } = DesignTokens;

const MACHINE_STATUS_RUNNING_ELLIPSIS_WIDTH = 14;
const MACHINE_STATUS_RUNNING_ELLIPSIS_SPACING = 2;

const Info = styled.div.withConfig({
  shouldForwardProp: (prop) => !["status"].includes(prop),
})<Pick<StatusInfoProps, "status">>`
  display: none;
  text-align: right;
  opacity: 0.5;
  flex-grow: 1;
  white-space: nowrap;
  margin-right: ${MACHINE_STATUS_RUNNING_ELLIPSIS_WIDTH}px;
  color: ${colors.gray.dark};

  ${({ status }) => {
    if (status === "running") {
      return css`
        && {
          &:after {
            position: absolute;
            margin-left: ${MACHINE_STATUS_RUNNING_ELLIPSIS_SPACING}px;
            overflow: hidden;
            content: "...";
            width: 0;
            animation: machine-status-running steps(4, end) 2s infinite;
            text-align: left;
          }

          @keyframes machine-status-running {
            to {
              width: ${MACHINE_STATUS_RUNNING_ELLIPSIS_WIDTH}px;
            }
          }
        }
      `;
    }

    if (status === "notconnected") {
      return css`
        && {
          color: ${colors.main.negative};
        }
      `;
    }

    if (status === "error") {
      return css`
        && {
          color: ${colors.main.negative};
        }
      `;
    }
  }}

  @media screen and (min-width: ${sizes.xl}px) {
    display: block;
  }
`;

type StatusInfoProps = {
  status: "running" | "stopped" | "notconnected" | "error";
};

export const StatusInfo: React.FC<StatusInfoProps> = ({ status }) => {
  const { t } = useTranslation();

  return <Info status={status}>{t(`view.status.${status}`)}</Info>;
};
